// Utilities
import createServiceAsyncThunk from "../../../../utils/reduxUtils/createServiceAsyncThunk";
import createGenericSlice from "../../../../utils/reduxUtils/createEntitySlice";

// Service
import { departmentService } from "../../../../Api/Services/DepartmentService"; // Importing the department service for API calls

// Types
import { IUserDetailsCommon } from "../../../../Types/Common";

// Constants
import { ACTION_NAMES, SLICE_NAMES } from "../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../constants/error";

/**
 * Async thunk to fetch department list.
 * Dispatches an API call to retrieve the department list.
 */
export const fetchDepartmentAsyncThunk = createServiceAsyncThunk<
  { data: Array<IUserDetailsCommon> },
  { status?: string } // 👈 make it optional
>(
  ACTION_NAMES.FETCH_DEPARTMENT_LIST,
  ({ status = "active" }) => departmentService.getAllDepartment(status),
  ERROR_MESSAGES.DEPARTMENT_LIST_FETCH_FAILURE
);


/**
 * Slice to manage the state of department list details.
 * Includes actions to clear errors and handle async states.
 */
export const departmentListSlice = createGenericSlice<
  { data: Array<IUserDetailsCommon> },
  { status?: string }
>(SLICE_NAMES.DEPARTMENT_LIST_SLICE, fetchDepartmentAsyncThunk);

export const {
  clearError: clearDepartmentListError,
  clearSuccessMessage: clearDepartmentListSuccess,
} = departmentListSlice.actions;

// Export the reducer to be included in the Redux store
export default departmentListSlice.reducer;
